import { InternMap } from "internmap";
export default function mode(values, valueof) {
    var counts = new InternMap();
    if (valueof === undefined) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            if (value != null && value >= value) {
                counts.set(value, (counts.get(value) || 0) + 1);
            }
        }
    }
    else {
        var index = -1;
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if ((value = valueof(value, ++index, values)) != null && value >= value) {
                counts.set(value, (counts.get(value) || 0) + 1);
            }
        }
    }
    var modeValue;
    var modeCount = 0;
    for (var _b = 0, counts_1 = counts; _b < counts_1.length; _b++) {
        var _c = counts_1[_b], value = _c[0], count = _c[1];
        if (count > modeCount) {
            modeCount = count;
            modeValue = value;
        }
    }
    return modeValue;
}
